// Facebook Pixel utility functions
// This file provides helper functions to track custom events with Facebook Pixel

// Check if we're on production domain
const isProductionDomain = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'helveticpadelseries.onrender.com' || 
         window.location.hostname === 'helveticpadelseries.ch' || 
         window.location.hostname === 'www.helveticpadelseries.ch';
};

// Check if Facebook Pixel is loaded
const isFbqLoaded = () => {
  return typeof window !== 'undefined' && window.fbq;
};

// Track a custom event (only on production)
// Optional eventId: Meta 4th-arg options.eventID for Pixel ↔ CAPI dedupe
export const trackEvent = (eventName, parameters = {}, eventId = null) => {
  console.log(`=== META PIXEL TRACK EVENT DEBUG ===`);
  console.log(`Event: ${eventName}`);
  console.log(`Parameters:`, parameters);
  console.log(`eventID:`, eventId || 'none');
  console.log(`Current domain: ${window.location.hostname}`);
  console.log(`Is production domain: ${isProductionDomain()}`);
  console.log(`Is fbq loaded: ${isFbqLoaded()}`);
  
  // Only track on production domain
  if (!isProductionDomain()) {
    console.log(`Facebook Pixel: Skipping event "${eventName}" (not on production domain)`);
    console.log(`Expected domains: helveticpadelseries.onrender.com, helveticpadelseries.ch, www.helveticpadelseries.ch`);
    return;
  }
  
  if (isFbqLoaded()) {
    try {
      if (eventId) {
        window.fbq('track', eventName, parameters, { eventID: String(eventId) });
      } else {
        window.fbq('track', eventName, parameters);
      }
      console.log(`✅ Facebook Pixel: Successfully tracked event "${eventName}"`, parameters, eventId || '');
    } catch (error) {
      console.error(`❌ Facebook Pixel: Error tracking event "${eventName}":`, error);
    }
  } else {
    console.warn('❌ Facebook Pixel not loaded, event not tracked:', eventName);
    console.log('Available window properties:', Object.keys(window).filter(key => key.includes('fb')));
  }
  
  console.log(`=== END META PIXEL TRACK EVENT DEBUG ===`);
};

// Track page view (useful for SPA navigation)
export const trackPageView = () => {
  // Only track on production domain
  if (!isProductionDomain()) {
    console.log('Facebook Pixel: Skipping PageView (not on production domain)');
    return;
  }
  
  if (isFbqLoaded()) {
    window.fbq('track', 'PageView');
    console.log('Facebook Pixel: Tracked PageView');
  }
};

// Track team registration (using standard Meta events)
export const trackRegistration = (teamName, canton) => {
  trackEvent('Lead', {
    content_name: 'Team Registration',
    content_category: 'Registration',
    value: 1,
    currency: 'CHF'
  });
};

// Track successful team registration conversion (after payment)
export const trackTeamRegistrationConversion = (teamData) => {
  trackEvent('Purchase', {
    content_name: 'Team Registration',
    content_category: 'Registration',
    value: 160,
    currency: 'CHF',
    content_ids: [teamData.team_id || teamData.id],
    num_items: 1
  });
};

export const trackPayment = (amount, teamName) => {
  trackEvent('Purchase', {
    value: amount,
    currency: 'CHF',
    content_name: 'Team Registration Fee',
    content_category: 'Payment',
    custom_data: {
      team_name: teamName
    }
  });
};

// Login tracking is handled directly in LoginPage component

export const trackContactForm = () => {
  trackEvent('Contact', {
    content_name: 'Contact Form Submission',
    content_category: 'Lead Generation'
  });
};

export const trackLeagueInfoView = () => {
  trackEvent('ViewContent', {
    content_name: 'League Information',
    content_category: 'Information'
  });
};

export const trackRulesView = () => {
  trackEvent('ViewContent', {
    content_name: 'League Rules',
    content_category: 'Information'
  });
};

export const trackPartnerClubsView = () => {
  trackEvent('ViewContent', {
    content_name: 'Partner Clubs',
    content_category: 'Information'
  });
};

// Initialize Facebook Pixel (called once when app loads)
export const initializePixel = () => {
  if (!isProductionDomain()) {
    console.log('Facebook Pixel: Skipping initialization (not on production domain)');
    return;
  }
  
  if (isFbqLoaded()) {
    console.log('Facebook Pixel initialized');
  } else {
    console.warn('Facebook Pixel not found');
  }
};
